import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class BarChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: {
                chart: {
                    toolbar: {
                        show: false,
                    },
                    animations: {
                        speed: 400,
                    },
                    foreColor: '#fff',
                },
                colors: ['#00ff7f', '#81e76b', '#acce57', '#cab343', '#e0962f', '#f1741a', '#ff4500'],
                plotOptions: {
                    bar: {
                        horizontal: true,
                        columnWidth: '45%',
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    theme: "dark",
                },
                xaxis: {
                    categories: ['7', '6', '5', '4', '3', '2', '1'],
                    labels: {
                        style: {
                            colors: '#fff',
                            fontSize: '14px'
                        },
                    },
                    title: {
                        text: 'Number of responses',
                        style: {
                            color: '#fff',
                            fontSize: '14px',
                            fontFamily: 'fira sans, Arial, sans-serif',
                        },
                    },
                    max: this.props.data.slice(-10).length * 3,
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: ['#00ff7f', '#81e76b', '#acce57', '#cab343', '#e0962f', '#f1741a', '#ff4500'],
                            fontSize: '14px'
                        }
                    },
                    title: {
                        text: 'Score',
                        style: {
                            color: '#fff',
                            fontSize: '14px',
                            fontFamily: 'fira sans, Arial, sans-serif',
                        },
                    }
                }
            },
            series: [{
                data: [26, 20, 5, 50, 16, 11, 3]
            }],
        }
    }

    // Get the 10 last datapoints and transform to array of arrays. 
    // Each array index inside the array corresponds to a question.
    getTransformedData() {
        let outputData = [];
        const limitedData = this.props.data.slice(-10);
        if (limitedData.length > 0) {
            limitedData.map((obj, i) => {
                return obj.answers.map((answer, j) => {
                    if (typeof outputData[j] === 'object') {
                        outputData[j].push(answer);
                    } else {
                        outputData[j] = [];
                        outputData[j].push(answer);
                    }
                });
            });
            return this.groupData(outputData)
        }
    }

    // Groups every three questions into one array. Resulting in 9 arrays 
    // corresponding to the nine dimensions that are visualized.
    groupData(input) {
        let outputData = [];
        if (input.length > 0) {
            input.map((answerArr, i) => {
                if (i % 3 === 0) {
                    let arr = input[i].concat(input[i + 1], input[i + 2]);
                    outputData.push(arr);
                }
            })
            return this.orderData(outputData);
        }
    }

    // Sorts the arrays inside so the score is lined up. 
    // Ex. from: [[3,2,5,2]...] to [[2,2,3,5]...]
    orderData(input) {
        const copiedArray = JSON.parse(JSON.stringify(input))
        copiedArray.map((arr, i) => {
            arr = arr.sort();
        });
        return this.getAmountOfOccurances(copiedArray);
    }

    // Counts the occurance of each vote 1-7.
    // Returns an array with amount of votes for each score 7-1
    getAmountOfOccurances(array) {
        let newArray = [];
        array.map(subArray => {
            let result = new Array(7).fill(0);
            subArray.map(element => {
                result[element - 1]++;
            })
            newArray.push(result);
        });
        return newArray[this.props.dimension - 1].reverse();
    }

    // Update the chart option on props update so the x-axis max adjusts to the data amount.
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState(prevState => ({
                ...prevState,
                options: {
                    ...prevState.options,
                    xaxis: {
                        ...prevState.options.xaxis,
                        max: this.props.data.slice(-10).length * 3
                    }
                }
            }));
        }
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart options={this.state.options} series={[{ data: this.getTransformedData() }]} type="bar" height="350" />
            </div>
        );
    }
}

export default BarChart;